'use client';

import React from 'react';
import styled from 'styled-components';

type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface AvatarProps {
  userName?: string;
  userAvatar?: string;
  size?: AvatarSize;
  onClick?: () => void;
}

const UserProfile = styled.div<{ $size?: AvatarSize }>`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
  cursor: ${props => props.onClick ? 'pointer' : 'default'};
  padding: 0;
  border-radius: ${props => props.theme.borderRadius.md};
  transition: background-color 0.2s ease-in-out;
`;

const AvatarCircle = styled.div<{ $userAvatar?: string; $size?: AvatarSize }>`
  width: ${props => props.theme.avatar.sizes[props.$size || 'md']};
  height: ${props => props.theme.avatar.sizes[props.$size || 'md']};
  border-radius: ${props => props.theme.borderRadius.full};
  background: ${props => (props.$userAvatar ? `url(${props.$userAvatar})` : '#3B4296')};
  background-size: cover;
  background-position: center;
  border: ${props => props.$userAvatar ? 'none' : `2px solid rgba(255, 255, 255, 0.2)`};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.text.inverse};
  font-weight: ${props => props.theme.fontWeights.semibold};
  font-size: ${props => {
    const size = props.$size || 'md';
    if (size === 'xs') return '0.625rem';
    if (size === 'sm') return '0.75rem';
    if (size === 'md') return '0.75rem';
    if (size === 'lg') return '1rem';
    return '1.25rem';
  }};
  line-height: ${props => props.theme.lineHeight.normal};
  flex-shrink: 0;
`;


export const Avatar: React.FC<AvatarProps> = ({
  userName = 'John Doe',
  userAvatar,
  size = 'md',
  onClick,
}) => {
  const words = userName?.trim().split(/\s+/).filter(word => word?.length > 0);
  const initials = words?.length >= 2
    ? (words[0][0] || '') + (words[1][0] || '')
    : (words[0] || 'JD').slice(0, 2);
  const formattedInitials = initials.toUpperCase();
  
  return (
    <UserProfile onClick={onClick} $size={size}>
      <AvatarCircle $userAvatar={userAvatar} $size={size}>
        {!userAvatar && formattedInitials}
      </AvatarCircle>
    </UserProfile>
  );
};

export default Avatar;

